"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M15 12.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-1 0a2 2 0 1 0-4 0 2 2 0 0 0 4 0"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M10 4.5a1.5 1.5 0 0 0-1.2.6l-.9 1.2a.5.5 0 0 1-.4.2h-2A2.5 2.5 0 0 0 3 9v7.5A2.5 2.5 0 0 0 5.5 19h13a2.5 2.5 0 0 0 2.5-2.5V9a2.5 2.5 0 0 0-2.5-2.5h-2a.5.5 0 0 1-.4-.2l-.9-1.2a1.5 1.5 0 0 0-1.2-.6zm-.4 1.2a.5.5 0 0 1 .4-.2h4a.5.5 0 0 1 .4.2l.9 1.2a1.5 1.5 0 0 0 1.2.6h2A1.5 1.5 0 0 1 20 9v7.5a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 16.5V9a1.5 1.5 0 0 1 1.5-1.5h2a1.5 1.5 0 0 0 1.2-.6z"
  })]
}), 'Camera');
//# sourceMappingURL=index.js.map